import React from 'react';
import Styles from './ErrorHandler.module.scss';
import PropTypes from 'prop-types';

export default class ErrorHandler extends React.Component {
  state = {
    error: 'Um erro',
  };
  componentWillUpdate(prevProps) {
    const { error } = this.state;
    const {
      location: { pathname },
    } = this.props;
    // If there is an error and the path changed lets clear the error
    if (error && prevProps.location.pathname !== pathname) {
      this.state.error = undefined;
    }
  }

  componentDidCatch(error) {
    const {
      location: { pathname },
    } = this.props;
    if (process.env.NODE_ENV === 'development') {
      console.error('Caught error ', error);
    }
    this.setState(
      {
        error: error.message,
        errorPathname: pathname,
      },
      () => {
        const { error } = this.state;
        console.error(error);
      },
    );
  }

  render() {
    const { error, errorPathname } = this.state;
    const {
      children,
      history,
      location: { pathname },
    } = this.props;
    return error && pathname === errorPathname ? (
      <div className={Styles.ErrorContainer}>
        <h1>Houve um erro na operação</h1>
        <p>
          Os dados trabalhados até o momento estão seguros.
          <br />
          Você será encaminhado de volta para a página inicial.
        </p>
        <button onClick={() => history.replace('/')}>Continuar</button>
      </div>
    ) : (
      children
    );
  }
}

ErrorHandler.propTypes = {
  children: PropTypes.any.isRequired,
  history: PropTypes.any.isRequired,
  location: PropTypes.any.isRequired,
};
